import { type CurrentUser } from "@overmap-ai/common"
import { HttpMethod, UserService as OvermapUserService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class UserService extends OvermapUserService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async get(): Promise<CurrentUser> {
		return this.performRequest({
			method: HttpMethod.GET,
			url: "/authentication/users/",
		})
	}
}
